// Extensiones de adjuntos permitidas para subir en documentos relacionados 
const EXTENSIONES_FACTURAE = [
  'XML',
  'XSIG',
  'TXT',
]

export {
  EXTENSIONES_FACTURAE
}
